import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-indigo-900 text-white">
      <div className="text-center p-8 max-w-md bg-gray-800 bg-opacity-50 rounded-lg shadow-2xl">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-6">Sayfa Bulunamadı</h2>
        <p className="mb-8 text-gray-300">
          Aradığınız sayfa bulunamadı veya taşınmış olabilir.
        </p>
        <div className="flex justify-center space-x-4">
          <Link
            to="/"
            className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg shadow-md transition-colors duration-300"
          >
            Ana Sayfaya Dön
          </Link>
          <Link
            to="/student-list"
            className="px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg shadow-md transition-colors duration-300"
          >
            Öğrenci Listesi
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 